<div [formGroup]="form" *ngIf="!dropdownConfigurations?.treeFormControlName" class="dropdown-container">
  <app-svg-icon *ngIf="dropdownIcon" class="dropdown-icon" [icon]="dropdownIcon"></app-svg-icon>
  <mat-select
    class="tree-select"
    formControlName="treeSelect"
    [dir]="layoutService.websiteDirection$.value"
    #Select
    [multiple]="dropdownConfigurations?.isMultipleSelect"
    (selectionChange)="onSelectionChange($event)"
    [placeholder]="'PLACEHOLDERS.'+dropdownConfigurations?.placeholder | translate"
  >
    <ng-container *ngIf="list?.length == 0">
      <mat-option [hidden]="true" disabled></mat-option>
      <div class="no-data">{{ "ERROR_MESSAGES.NO_DATA_EXIST" | translate }}</div>
    </ng-container>
    <input
      *ngIf="enableSearch"
      type="text"
      class="search_input"
      #input
      (input)="onSearch($event)"
      [placeholder]="'PLACEHOLDERS.SEARCH' | translate"
      name="searchDDL"
    />
    <mat-divider></mat-divider>
    <ng-container *ngFor="let item of list | dropDownFilter : search : 'dropDownDisplayName'">
      <mat-option
        [style.display]="item.hidden ? 'none' : ''"
        id="dd"
        [value]="item.id"
        [ngStyle]="layoutService.websiteDirection$.value == 'rtl' ? {'margin-right': item?.['level']*10+'px'} : {'margin-left': item?.['level']*10+'px'}"
      >
        <div fxLayout="row" fxFlexAlign="space-between center">
          <div class="p-l-15">{{ item.dropDownDisplayName }}</div>
        </div>
      </mat-option>
      <ng-container *ngIf="loading">
        <app-spinner [size]="SpinnerSize.ULTRA_SMALL"></app-spinner>
      </ng-container>
    </ng-container>
  </mat-select>
</div>

<div *ngIf="dropdownConfigurations?.treeFormControlName" class="dropdown-container">
  <app-svg-icon *ngIf="dropdownIcon" class="dropdown-icon" [icon]="dropdownIcon"></app-svg-icon>
  <mat-select
    class="tree-select"
    [ngClass]="dropdownIcon ? 'hasIcon' : ''"
    [formControlName]="dropdownConfigurations?.treeFormControlName"
    [dir]="layoutService.websiteDirection$.value"
    #Select
    [multiple]="dropdownConfigurations?.isMultipleSelect"
    (selectionChange)="onSelectionChange($event)"
    [placeholder]="'PLACEHOLDERS.'+dropdownConfigurations?.placeholder | translate"
  >
    <ng-container *ngIf="list?.length == 0">
      <mat-option [hidden]="true" disabled></mat-option>
      <div class="no-data">{{ "ERROR_MESSAGES.NO_DATA_EXIST" | translate }}</div>
    </ng-container>
    <input
      type="text"
      class="search_input"
      #input
      (input)="onSearch($event)"
      [placeholder]="'PLACEHOLDERS.SEARCH' | translate"
      name="searchDDL"
      *ngIf="list?.length > 0 && enableSearch"
    />
    <mat-divider></mat-divider>
    <ng-container *ngFor="let item of list | dropDownFilter : search : 'dropDownDisplayName'">
      <ng-container *ngIf="!optionCustomTemplate">
        <mat-option
          [style.display]="item.hidden ? 'none' : ''"
          id="dd"
          [value]="item.id"
          [ngStyle]="layoutService.websiteDirection$.value == 'rtl' ? {'margin-right': item?.['level']*10+'px'} : {'margin-left': item?.['level']*10+'px'}"
        >
          <div fxLayout="row" fxFlexAlign="space-between center">
            <div class="p-l-15">{{ item.dropDownDisplayName }}</div>
          </div>
        </mat-option>
      </ng-container>
      <ng-container *ngIf="optionCustomTemplate">
        <mat-option
          id="dd"
          [value]="item.id"
          [ngStyle]="layoutService.websiteDirection$.value == 'rtl' ? {'margin-right': item?.['level']*10+'px'} : {'margin-left': item?.['level']*10+'px'}"
        >
          <ng-template [ngTemplateOutlet]="optionCustomTemplate" [ngTemplateOutletContext]="{ option: item }"></ng-template>
        </mat-option>
      </ng-container>

      <ng-container *ngIf="loading">
        <app-spinner [size]="SpinnerSize.ULTRA_SMALL"></app-spinner>
      </ng-container>
    </ng-container>
  </mat-select>
</div>
